// extracted by mini-css-extract-plugin
export var externalArticleList = "externalArticleList-module--externalArticleList--2956e";
export var header = "externalArticleList-module--header--fd2f9";
export var innerWrapper = "externalArticleList-module--innerWrapper--1ecc8";
export var slideUp = "externalArticleList-module--slideUp--6d18f";
export var slideUpLarge = "externalArticleList-module--slideUpLarge--f5ee1";
export var spacer = "externalArticleList-module--spacer--4fc7a";
export var spacerWrapper = "externalArticleList-module--spacerWrapper--2e15a";